export function chromeIntentUrl({ host, pathname, search }) {
  return `intent://${host}${pathname}${search || ""}#Intent;scheme=https;package=com.android.chrome;end`;
}

const META_APPS = /FBAN|FBAV|FB_IAB|Instagram/i

export function shouldPromptOpenInBrowser(ua) {
  if (META_APPS.test(ua)) return false

  const isAndroid = /Android/i.test(ua)
  const hasWV = /\bwv\b/.test(ua) || /\bVersion\/[\d.]+/i.test(ua)
  const isInAppBrowser = /(GSA|Gmail|Line|LinkedInApp|Twitter)/i.test(ua)

  return isAndroid && (hasWV || isInAppBrowser)
}
